export default __webpack_public_path__ + "static/media/фото-128 2.a99c968c.jpg";